const BASE = process.env.REACT_APP_API_URL || "";

enum NetworkErrno {
  USER_ERR = 0,
  SERV_ERR, // server error
  PRGM_ERR, // programmer error
  REQT_ERR, // request error
}
class NetworkError extends Error {
  code: number;
  text: string;
  type: NetworkErrno;
  constructor(code: number, text: string, type: NetworkErrno) {
    super(text);
    this.code = code;
    this.text = text;
    this.type = type;
  }
}
export const handleRequest = async (res: Response) => {
  try {
    // successful response?
    if (!res.ok) {
      throw new NetworkError(res.status, res.statusText, NetworkErrno.REQT_ERR);
    }
    // what's in InfoGet?
    const { Data, InfoGet } = await res.json();
    const status = InfoGet[0]?.Status || "";
    const code = InfoGet[0]?.Code || "";
    if (status === "Error") {
      throw new NetworkError(code, status, NetworkErrno.PRGM_ERR);
    } else if (status === "Fail") {
      throw new NetworkError(code, status, NetworkErrno.USER_ERR);
    } else {
      return Data;
    }
  } catch (e) {
    const { code, text, type } = e as NetworkError;
    switch (type) {
      case NetworkErrno.SERV_ERR:
        alert(text);
        break;
      case NetworkErrno.USER_ERR:
        alert(text);
        break;
      case NetworkErrno.PRGM_ERR:
        if (process.env.NODE_ENV !== "production") {
          console.error(
            `NETWORK ERROR: ${NetworkErrno[type]}\ncode: ${code}\nStatusText: ${text}\n`
          );
        }
        break;
      case NetworkErrno.REQT_ERR:
        switch (code) {
          case 404:
            alert("格式錯誤");
            break;
          default:
            if (process.env.NODE_ENV !== "production") {
              console.error(
                `NETWORK ERROR: ${NetworkErrno[type]}\ncode: ${code}\nStatusText: ${text}\n`
              );
            }
        }
        break;
    }
    return [];
  }
};
export const GETJsonProvince = async () =>
  handleRequest(await fetch(`${BASE}ApiGetJsonProvince.ashx`));
export const GETJsonCity = async (pid: number) =>
  handleRequest(await fetch(`${BASE}ApiGetJsonCity.ashx?Pid=${pid}`));
export const GETJsonTbgroup = async (cityID: number) =>
  handleRequest(await fetch(`${BASE}ApiGetJsontbgroup.ashx?CityID=${cityID}`));
export const GETJsonMatch = async (gid: number) =>
  handleRequest(await fetch(`${BASE}ApiGetJsonMatch.ashx?Gid=${gid}`));
export const GETJsonMatchGame = async (
  matchID: string,
  matchGameType: number
) =>
  handleRequest(
    await fetch(
      `${BASE}ApiGetJsonMatchGame.ashx?MatchID=${matchID}&MatchGameType=${matchGameType}`
    )
  );
export const GETJsonGameID = async (matchID: number, gameType: number) =>
  handleRequest(
    await fetch(
      `${BASE}ApiGetJsonGameID.ashx?mID=${matchID}&gameType=${gameType}`,
      {
        method: "GET",
        headers: {
          "content-Type": "application/json; charset=utf-8",
        },
      }
    )
  );
export const GETJsonMessageTbgroup = async (token: string) =>
  handleRequest(
    await fetch(`${BASE}ApiGetJsonMessageTbgroup.ashx`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    })
  );
export const GETJsonMessageTbgroupNoToken = async () =>
  handleRequest(await fetch(`${BASE}ApiGetJsonMessageTbgroupNoToken.ashx`));
export const GETJsonMessageDaily = async (
  clubGid: string,
  startTime: string,
  endTime: string,
  rank: "ASC" | "DES",
  pageSize: number,
  current: number,
  searchFeetNo: string,
  searchName: string,
  memberName: string,
  isChecked: boolean
) =>
  handleRequest(
    await fetch(
      `${BASE}ApiGetJsonMessageDaily.ashx?Gid=${clubGid}&StartDay=${startTime}&EndDay=${endTime}&Sort=${rank}&PageSize=${pageSize}&NowPage=${current}&SearchFeetNo=${searchFeetNo}&SearchNumber=${searchName}&SearchName=${encodeURIComponent(
        memberName
      )}&Filter=${isChecked}`
    )
  );
export const GETJsonDailyExportData = async (
  Gid: any,
  StartDay: any,
  EndDay: any,
  Sort: any,
  SearchFeetNo: any,
  SearchNumber: any,
  SearchName: any,
  Filter: any,
  token: any
) =>
  handleRequest(
    await fetch(
      `${BASE}ApiGetJsonDailyExportData.ashx?Gid=${Gid}&StartDay=${StartDay}&EndDay=${EndDay}&Sort=${Sort}&SearchFeetNo=${SearchFeetNo}&SearchNumber=${SearchNumber}&SearchName=${SearchName}&Filter=${Filter}`,
      {
        headers: {
          Authorization: token,
        },
      }
    )
  );
// contains special logic, do not wrap around handleRequest()
export const POSTJsonTokenCheckOrRefresh = (token: string) =>
  fetch(`${BASE}ApiPostJsonToken_CheckOrRefresh.ashx`, {
    headers: {
      "Content-Type": "application/json; charset:utf-8",
      Authorization: token,
    },
    method: "POST",
  }).then((res) => res.json());
export const GETJsonMessageDailyActionID = (
  gid: string | number,
  actionID: string,
  sort: string,
  pageSize: number | string,
  nowPage: number | string,
  searchFeetNo: number | string,
  searchNumber: number | string,
  searchName: string,
  filter: boolean,
  token: string
) =>
  fetch(
    `${BASE}ApiGetJsonMessageDaily_ActionID.ashx?Gid=${gid}&ActionID=${actionID}&Sort=${sort}&PageSize=${pageSize}&NowPage=${nowPage}&SearchFeetNo=${searchFeetNo}&SearchNumber=${searchNumber}&SearchName=${searchName}&Filter=${filter}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: token,
      },
    }
  ).then((res) => res.json());
export const GETJsonDailyExportDataAction = (
  gid: string | number,
  actionID: string,
  sort: string,
  searchFeetNo: string | number,
  searchNumber: string | number,
  searchName: string,
  filter: boolean,
  token: string
) =>
  fetch(
    `${BASE}ApiGetJsonDailyExportData_Action.ashx?Gid=${gid}&ActionID=${actionID}&Sort=${sort}&SearchFeetNo=${searchFeetNo}&SearchNumber=${searchNumber}&SearchName=${searchName}&Filter=${filter}`,
    {
      headers: {
        Authorization: token,
      },
    }
  ).then((res) => res.json());
export const GETJsonDeviceActionIDList = (
  gid: string | number,
  token: string
) =>
  fetch(`${BASE}ApiGetJsonDeviceActionIdList.ashx?Gid=${gid}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: token,
    },
  }).then((res) => res.json());
export const POSTJsonLoginGetToken = (body: {
  Account: string;
  Password: string;
  Id: string;
}) =>
  fetch(`${BASE}ApiPostJsonLoginGetToken.ashx`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "Access-Control-Headers": "*",
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());
export const GETJsonDeviceSensorCodeCount = (
  Gid: string | number,
  StartDay: string,
  EndDay: string,
  ID: string,
  token: string
) =>
  fetch(
    `${BASE}ApiGetJsonDeviceSensorCodeCount.ashx?Gid=${Gid}&StartDay=${StartDay}&EndDay=${EndDay}&ID=${encodeURIComponent(
      ID
    )}`,
    {
      headers: {
        Authorization: token,
      },
    }
  ).then((res) => res.json());
export const GETJsonDeviceList = (gid: number | string, token: string) =>
  fetch(`${BASE}ApiGetJsonDeviceList.ashx?Gid=${gid}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: token,
    },
  }).then((res) => res.json());
export const GETJsonDeviceConnectInfoList = (
  gid: number | string,
  token: string
) =>
  fetch(`${BASE}ApiGetJsonDeviceConnectInfoList.ashx?Gid=${gid}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: token,
    },
  }).then((res) => res.json());
export const GETJsonDeviceActionIDTime = (
  gid: number | string,
  token: string
) =>
  fetch(`${BASE}ApiGetJsonDeviceActionidTime.ashx?Gid=${gid}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: token,
    },
  }).then((res) => res.json());
export const POSTJsonDeviceListEdit = (
  token: string,
  body: {
    Gid: string;
    DeviceUUID: string;
    Did: string;
    DeviceName: string;
  }
) =>
  fetch(`${process.env.REACT_APP_API_URL}ApiPostJsonDeviceList_Edit.ashx`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: token || "",
    },
    body: JSON.stringify(body),
  }).then((res) => res.json());

type PageSetting = "racelive" | "globaltopmenu";
export const GETJsonRaceLiveSetting = (gid: number, page: PageSetting) =>
  fetch(
    `${process.env.REACT_APP_API_URL}ApiGetJsonRaceLiveSetting.ashx?gid=${gid}&page=${page}`
  )
    .then((res) => res.json())
    .then((json) => json.Data);
export const POSTJsonRaceLiveSetting = (
  gid: number,
  page: PageSetting,
  token: string,
  body: Record<string, number>
) => {
  const processedBody = Object.entries(body).map(([k, v]) => ({
    clubID: gid,
    settingPage: page,
    settingName: k,
    settingValue1: v.toString(),
  }));

  return fetch(
    `${process.env.REACT_APP_API_URL}ApiPostJsonRaceLiveSetting.ashx`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: token,
      },
      body: JSON.stringify(processedBody),
    }
  );
};
